import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getUserPlanAction,
  updateUserPlanAction,
  upgradeUserPlanAction,
  downgradeUserPlanAction,
} from "./userPlanSliceActions";
import { userPlanSliceInitialState } from "./userPlanSliceInitialState";

const initialState = userPlanSliceInitialState;

const userPlanSlice = createSlice({
  name: "userPlan",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updatePlanField: (state, action) => {
      if (state.plan) {
        state.plan[action.payload.field] = action.payload.value;
      }
    },
    resetUserPlanState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get User Plan
    builder.addCase(getUserPlanAction.fulfilled, (state, action) => {
      state.apiStatus.getPlan = API_STATUS.COMPLETED;
      state.plan = action.payload;
      state.error = null;
    });
    builder.addCase(getUserPlanAction.pending, (state) => {
      state.apiStatus.getPlan = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getUserPlanAction.rejected, (state, action) => {
      state.apiStatus.getPlan = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update User Plan
    builder.addCase(updateUserPlanAction.fulfilled, (state, action) => {
      state.apiStatus.updatePlan = API_STATUS.COMPLETED;
      state.plan = action.payload;
      state.error = null;
    });
    builder.addCase(updateUserPlanAction.pending, (state) => {
      state.apiStatus.updatePlan = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateUserPlanAction.rejected, (state, action) => {
      state.apiStatus.updatePlan = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Upgrade User Plan
    builder.addCase(upgradeUserPlanAction.fulfilled, (state, action) => {
      state.apiStatus.upgradePlan = API_STATUS.COMPLETED;
      state.plan = action.payload;
      state.error = null;
    });
    builder.addCase(upgradeUserPlanAction.pending, (state) => {
      state.apiStatus.upgradePlan = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(upgradeUserPlanAction.rejected, (state, action) => {
      state.apiStatus.upgradePlan = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Downgrade User Plan
    builder.addCase(downgradeUserPlanAction.fulfilled, (state, action) => {
      state.apiStatus.downgradePlan = API_STATUS.COMPLETED;
      state.plan = action.payload;
      state.error = null;
    });
    builder.addCase(downgradeUserPlanAction.pending, (state) => {
      state.apiStatus.downgradePlan = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(downgradeUserPlanAction.rejected, (state, action) => {
      state.apiStatus.downgradePlan = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const { clearError, updatePlanField, resetUserPlanState } =
  userPlanSlice.actions;

export default userPlanSlice.reducer;
